import { render, staticRenderFns } from "./create-examination.vue?vue&type=template&id=4e1fd306&scoped=true"
import script from "./create-examination.vue?vue&type=script&lang=js"
export * from "./create-examination.vue?vue&type=script&lang=js"
import style0 from "./create-examination.vue?vue&type=style&index=0&id=4e1fd306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1fd306",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default})
